import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useFriskvardPayments } from '@/api/hooks/useFriskvardPayments'
import { StateSwitcher } from '@/components/atoms/state-switcher'
import PageLayout from '@/components/layout/page-layout'
import FriskvardTable from '@/components/organisms/friskvard-table/friskvard-table'

export const Route = createFileRoute('/_authenticated/friskvard')({
  component: FriskvardPage,
})

function FriskvardPage() {
  const { t } = useTranslation()
  const { data: payments = [], isError, isLoading } = useFriskvardPayments()

  return (
    <PageLayout title={t('navigation.friskvard')}>
      <StateSwitcher isError={isError} isLoading={isLoading}>
        <FriskvardTable payments={payments} />
      </StateSwitcher>
    </PageLayout>
  )
}
